import { Box3, Object3D, Vector3, gsap, use } from '@anov/3d-core'
import type { SceneControl } from '@anov/3d-core'
import type { GrowOption, IGrowStyle } from './type'
import { EEaseType, ESceneGrowType } from './type'
import { GrowStyleDown, GrowStyleUp } from './growStyle'

// 生长动画对象
export class Grow {
  private objs: Array<Object3D>
  private option: GrowOption
  private growStyle: IGrowStyle
  private sceneControl: SceneControl

  constructor(opt: GrowOption | undefined, sceneControl: SceneControl) {
    this.objs = []
    this.option = {}
    // @ts-ignore
    this.growStyle = null
    this.sceneControl = sceneControl
    this.init(opt || {})
  }

  // 生长
  in(callback: () => void) {
    // 入场事件
    this.option.onGrowInStart && this.option.onGrowInStart()

    this.growStyle.getTimeLine().eventCallback('onComplete', () => {
      this.option.onGrowInCompleted && this.option.onGrowInCompleted()
      callback && callback()
    })

    this.growStyle.in()
  }

  // 消退
  out(callback: () => void) {
    // 出场事件
    this.option.onGrowOutStart && this.option.onGrowOutStart()

    this.growStyle.getTimeLine().eventCallback('onReverseComplete', () => {
      this.option.onGrowOutCompleted && this.option.onGrowOutCompleted()

      callback && callback()
    })

    this.growStyle.out()
  }

  // 初始化
  init(opt: GrowOption) {
    this.option = {
      tag: '*', // 可选,进场对象Tag, 默认 "*" 所有可见MESH对象,
      type: ESceneGrowType.Up, // 可选,进场动画类型,默认 ESceneGrowType.Up向上生长
      time: 0.5, // 可选,单对象进场时间,默认0.5秒
      gapTime: 0.2, // 可选,多个对象之间间隔事件,默认0.2秒
      ease: EEaseType.SineInOut, // 可选,默认缓入缓出
      center: null, // 可选,生长中心位置,默认包围盒中心点
      scale: 1, // 可选，倍速，默认为1。
      distance: 1000, // 可选,初始化UP/DOWN起始距离，默认1000
      isRotate: true, // 可选,初始化UP/DOWN起始旋转角度，默认true
      isScale: true, // 可选,初始化UP/DOWN起始缩放大小，默认true
    }
    Object.assign(this.option, opt)
    // ------- 1.初始化目标对象 --------
    this.objs.length = 0
    // 获取所有对象
    if (this.option.tag === '*') {
      use.useScene(this.sceneControl).scene!.traverseVisible((object) => {
        if (object instanceof Object3D)
          this.objs.push(object)
      })
    }
    else { // 获取指定tag对象
      use.useScene(this.sceneControl).scene!.traverseVisible((object) => {
        if (object instanceof Object3D && object.userData.tag && Array.isArray(object.userData.tag) && object.userData.tag.includes(this.option.tag))
          this.objs.push(object)
      })
    }

    // ------- 2.中心点 ------------
    if (!this.option.center) {
      const boundingBox = new Box3()

      // 将每个物体的边界框扩展到包围盒中
      for (let i = 0; i < this.objs.length; i++) {
        const object = this.objs[i]
        boundingBox.expandByObject(object)
      }
      // 计算包围盒的中心点
      const center = new Vector3()
      this.option.center = boundingBox.getCenter(center)
    }

    // ------- 2.初始化目标对象 生长前状态 --------
    switch (this.option.type) {
      case ESceneGrowType.Up:
        this.growStyle = new GrowStyleUp(this.objs, this.option)
        break
      case ESceneGrowType.Down:
        this.growStyle = new GrowStyleDown(this.objs, this.option)
        break
      default:
        this.growStyle = new GrowStyleUp(this.objs, this.option)
        break
    }
    this.growStyle.init()
    this.option.onGrowInitCompleted && this.option.onGrowInitCompleted()
  }
}
